// extracted by mini-css-extract-plugin
module.exports = {"scoreText":"ResultPage_scoreText__2fWI3 base-styles_coloredText__33MPY","playAgainBtnBox":"ResultPage_playAgainBtnBox__2laW-"};